import { useCallback } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { getProposalResponseAcceptedKey } from 'v2/utils/proposalUtils';

export const useProposalResponseAccepted = ({
  proposalId,
  searchId,
}: {
  proposalId: number;
  searchId: number;
}) => {
  const queryClient = useQueryClient();
  const key = getProposalResponseAcceptedKey(proposalId, searchId);
  const result = useQuery([key], () => localStorage.getItem(key));

  const setResponseKey = useCallback(() => {
    localStorage.setItem(key, 'accepted');
    queryClient.invalidateQueries([key]);
  }, [key, queryClient]);

  const removeResponseKey = useCallback(() => {
    localStorage.removeItem(key);
    queryClient.invalidateQueries([key]);
  }, [key, queryClient]);

  return {
    ...result,
    setResponseKey,
    removeResponseKey,
  };
};
